import Vue from 'vue'
//路由模块引入
import Router from 'vue-router'
Vue.use(Router)

import store from '@/vuex/store';


// import pic from '@/components/pic'
import cropper from '@/components/cropper.vue'
//前台页面路由
import Index from '@/components/Index'		//首页
import Search from '@/components/Search.vue';		//搜索
import Baike from '@/components/Baike.vue';		//艺人列表
import BaikeContent from '@/components/BaikeContent.vue';		//艺人详情
import Juzu from '@/components/Juzu.vue';		//剧组列表
import JuzuContent from '@/components/JuzuContent.vue';		//剧组详情
import Hot from '@/components/Hot.vue';		//热点新闻列表
import HotContent from '@/components/HotContent.vue';		//热点新闻详情
import Video from '@/components/Video.vue';		//视频列表
import VideoContent from '@/components/VideoContent.vue';		//视频详情
import Login from '@/components/Login.vue';		//登录
import Register from '@/components/Register.vue';  //注册
import Forgetpwd from '@/components/Forgetpwd.vue'; //忘记密码
import Pics from '@/components/Pics.vue';   //图集

//艺人后台路由
import Personal from '@/components/per_admin/Personal.vue'  //艺人后台首页
import P_Edit from '@/components/per_admin/P_Edit'		//
import P_Received from '@/components/per_admin/P_Received.vue'
import P_Collection from '@/components/per_admin/P_Collection.vue'
import P_BkCollect from '@/components/per_admin/collect/P_BkCollect.vue'
import P_JzCollect from '@/components/per_admin/collect/P_JzCollect.vue'
import P_ChangePwd from '@/components/per_admin/change/P_ChangePwd.vue'
import P_Change from '@/components/per_admin/P_Change.vue'
import P_ChangeMobile from '@/components/per_admin/change/P_ChangeMobile.vue'
import P_ChangeInfo from '@/components/per_admin/change/P_ChangeInfo.vue'
import P_Wdsp from '@/components/per_admin/edit/P_Wdsp.vue'
import P_Wdxz from '@/components/per_admin/edit/P_Wdxz.vue'
import P_Jbxx from '@/components/per_admin/edit/P_Jbxx.vue'
import P_Bind from '@/components/per_admin/P_Bind.vue'
import P_Feedback from '@/components/per_admin/P_Feedback.vue'
import P_Perinfor from '@/components/per_admin/P_Perinfor.vue'
import P_Missing from '@/components/per_admin/P_Missing.vue'
import P_Authen from '@/components/per_admin/P_Authen.vue'
//剧组后台路由
import Group from '@/components/group_admin/Group.vue'
import G_Edit from '@/components/group_admin/G_Edit.vue'
import G_Release from '@/components/group_admin/G_Release.vue'
import G_Received from '@/components/group_admin/G_Received.vue'
import G_Collection from '@/components/group_admin/G_Collection.vue'
import G_Change from '@/components/group_admin/G_Change.vue'
import G_ChangePwd from '@/components/group_admin/change/G_ChangePwd.vue'
import G_ChangeMobile from '@/components/group_admin/change/G_ChangeMobile.vue'
import G_ChangeInfo from '@/components/group_admin/change/G_ChangeInfo.vue'
import G_GroupInfor from '@/components/group_admin/G_GroupInfor.vue'
import G_BkCollect from '@/components/group_admin/collect/G_BkCollect.vue'
import G_JzCollect from '@/components/group_admin/collect/G_JzCollect.vue'
import G_Bind from '@/components/group_admin/G_Bind.vue'
import G_Feedback from '@/components/group_admin/G_Feedback.vue'
import G_Missing from '@/components/group_admin/G_Missing.vue'
import G_Ypxx from '@/components/group_admin/edit/G_Ypxx.vue'
import G_Zcry from '@/components/group_admin/edit/G_Zcry.vue'
import G_Zmyy from '@/components/group_admin/edit/G_Zmyy.vue'
import G_Infor from '@/components/group_admin/edit/G_Infor.vue'
import G_Email from '@/components/group_admin/received/G_Email.vue'
import G_StarEmail from '@/components/group_admin/received/G_StarEmail.vue'
import G_Authen from '@/components/group_admin/G_Authen.vue'

if (localStorage.getItem('token')) {			//起作用，2019.01.14测试，传递token
	store.commit('set_token', localStorage.getItem('token'))
}
//
const router = new Router({
    mode: 'history',
	linkActiveClass:'active',
	routes: [
		{
			path: '/',
			name: 'Index',
			component: Index
		},
		{
			path: '/cropper',
			name: 'cropper',
			component: cropper
		},
		{
			path: '/search',
			name: 'Search',
			component: Search
		},

		{
			path: '/baike',
			name: 'Baike',
			component: Baike
		},
		{
			path: '/baikecontent/:id',
			name: 'BaikeContent',
			component: BaikeContent
		},
		{
			path: '/pics',
			name: 'Pics',
			component: Pics
		},
		{
			path: '/juzu',
			name: 'Juzu',
			component: Juzu
		},
		{
			path: '/juzucontent/:id',
			name: 'JuzuContent',
			component: JuzuContent
		},
		{
			path: '/hot',
			name: 'Hot',
			component: Hot
		},
		{
			path: '/hotcontent/:id',
			name: 'HotContent',
			component: HotContent
		},
		{
			path: '/video',
			name: 'Video',
			component: Video
		},
		{
			path: '/videocontent/:id',
			name: 'VideoContent',
			component: VideoContent
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			meta:{
				publicShow: true
			}
		},
		{
			path: '/register',
			name: 'Register',
			component: Register,
			meta:{
				publicShow: true
			}
		},
		{
			path: '/forgetpwd',
			name: 'Forgetpwd',
			component: Forgetpwd,

		},
		{																//----------------------艺人路由----------------------//
			path: '/per_admin/personal',
			name: 'Personal',
			component: Personal,

			children: [{
				path: '/per_admin/edit',
				name: 'P_Edit',
				component: P_Edit,

				children: [{
						path: '/per_admin/edit/jbxx',
						name: 'P_Jbxx',
						component: P_Jbxx,

					},
					{
						path: '/per_admin/edit/wdxz',
						name: 'P_Wdxz',
						component: P_Wdxz,
					},
					{
						path: '/per_admin/edit/wdsp',
						name: 'P_Wdsp',
						component: P_Wdsp,
					}
				]
			},
			{
				path: '/per_admin/perinfor',
				name: 'P_Perinfor',
				component: P_Perinfor,
			},
			{
				path: '/per_admin/missing',
				name: 'P_Missing',
				component: P_Missing,
			},
			{
				path: '/per_admin/received',
				name: 'P_Received',
				component: P_Received,
			},
			{
				path: '/per_admin/authen',
				name: 'P_Authen',
				component: P_Authen,
			},
			{
				path: '/per_admin/collection',
				name: 'P_Collection',
				component: P_Collection,
				children: [
					{
						path: '/per_admin/collect/jzcollect',
						name: 'P_JzCollect',
						component: P_JzCollect
					},
					{
						path: '/per_admin/collect/bkcollect',
						name: 'P_BkCollect',
						component: P_BkCollect
					}
				]
			},
			{
				path: '/per_admin/change',
				name: 'P_Change',
				component: P_Change,
				children:[
					{
						path: '/per_admin/change/changeinfo',
						name: 'P_ChangeInfo',
						component: P_ChangeInfo,
					},
					{
						path: '/per_admin/change/changepwd',
						name: 'P_ChangePwd',
						component: P_ChangePwd,
					},
					{
						path: '/per_admin/change/changemobile',
						name: 'P_ChangeMobile',
						component: P_ChangeMobile,
					}
				]
			},
			{
				path: '/per_admin/bind',
				name: 'P_Bind',
				component: P_Bind,
			},
			{
				path: '/per_admin/feedback',
				name: 'P_Feedback',
				component: P_Feedback,
			},



			]
		},
		{																							//----------------------剧组路由----------------------//
			path: '/group_admin/group',
			name: 'Group',
			component: Group,

			children: [{
					path: '/group_admin/edit',
					name: 'Edit',
					component: G_Edit,
					//meta: { requireAuth: true }, //登录验权
					children: [{
							path: '/group_admin/edit/ypxx',
							name: 'G_Ypxx',
							component: G_Ypxx,
							//meta: { requireAuth: true }, //登录验权
						},
						{
							path: '/group_admin/edit/zcry',
							name: 'G_Zcry',
							component: G_Zcry,
						},
						{
							path: '/group_admin/edit/zmyy',
							name: 'G_Zmyy',
							component: G_Zmyy,
						},
						{
							path: '/group_admin/edit/infor',
							name: 'G_Infor',
							component: G_Infor,
						},
					]
				},
				{
					path: '/group_admin/bind',
					name: 'G_Bind',
					component: G_Bind
				},
				{
					path: '/group_admin/change',
					name: 'G_Change',
					component: G_Change,
					children: [{
							path: '/group_admin/change/changepwd',
							name: 'G_ChangePwd',
							component: G_ChangePwd,
							//meta: { requireAuth: true }, //登录验权
						},
						{
							path: '/group_admin/change/changemobile',
							name: 'G_ChangeMobile',
							component: G_ChangeMobile,
						}, ,
						{
							path: '/group_admin/change/changeinfo',
							name: 'G_ChangeInfo',
							component: G_ChangeInfo,
						},
					]
				},
				{
					path: '/group_admin/collection',
					name: 'Collection',
					component: G_Collection,
					children: [{
							path: '/group_admin/collect/jzcollect',
							name: 'G_JzCollect',
							component: G_JzCollect
						},
						{
							path: '/group_admin/collect/bkcollect',
							name: 'G_BkCollect',
							component: G_BkCollect
						}
					]
				},
				{
					path: '/group_admin/received',
					name: 'G_Received',
					component: G_Received,
					children:[
						{
							path:'/group_admin/received/email',
							name:'G_Email',
							component:G_Email
						},
						{
							path:'/group_admin/received/staremail',
							name:'G_StarEmail',
							component:G_StarEmail
						},
						]
				},
				{
					path: '/group_admin/release',
					name: 'G_Release',
					component: G_Release
				},
				{
					path: '/group_admin/feedback',
					name: 'G_Feedback',
					component: G_Feedback
				},
				{
					path: '/group_admin/missing',
					name: 'G_Missing',
					component: G_Missing
				},
				{
					path: '/group_admin/groupinfor/:id',
					name: 'G_GroupInfor',
					component: G_GroupInfor
				},
				{
					path: '/group_admin/authen',
					name: 'G_Authen',
					component: G_Authen
				}
			]
		},

	],
    scrollBehavior(to, from,savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = document.body.scrollTop = 0;
	if (to.matched.some(r => r.meta.requireAuth)) { //这里的requireAuth为路由中定义的 meta:{requireAuth:true}，意思为：该路由添加该字段，表示进入该路由需要登陆的
		if (store.state.token) {
			next();
		} else {
			next({
				path: '/login',
				query: {redirect: to.fullPath}
			})
		}
	} else {
		next();
	}
})
router.afterEach(() => {  //控制页面跳转路由后浏览位置初始化顶部
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js